import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
]);
import Router from 'vue-router';
const Home = () => import('../core/home/home.vue');
const Error = () => import('../core/error/error.vue');
const Register = () => import('../account/register/register.vue');
const Activate = () => import('../account/activate/activate.vue');
const ResetPasswordInit = () => import('../account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('../account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('../account/change-password/change-password.vue');
const Settings = () => import('../account/settings/settings.vue');
const Email = () => import('../admin/email/email.vue');

const EmailCampaign = () => import('../admin/email-campaign/email-campaign.vue');
const EmailCampaignViewComponent = () => import('../admin/email-campaign/email-campaign-view.vue');
const EmailCampaignEditComponent = () => import('../admin/email-campaign/email-campaign-edit.vue');

const JhiUserManagementComponent = () => import('../admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('../admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('../admin/user-management/user-management-edit.vue');
const JhiConfigurationComponent = () => import('../admin/configuration/configuration.vue');
const JhiDocsComponent = () => import('../admin/docs/docs.vue');
const JhiHealthComponent = () => import('../admin/health/health.vue');
const JhiLogsComponent = () => import('../admin/logs/logs.vue');
const JhiAuditsComponent = () => import('../admin/audits/audits.vue');
const JhiMetricsComponent = () => import('../admin/metrics/metrics.vue');
/* tslint:disable */
// prettier-ignore
const MerchantUser = () => import('../entities/merchant-user/merchant-user.vue');
// prettier-ignore
const MerchantUserUpdate = () => import('../entities/merchant-user/merchant-user-update.vue');
// prettier-ignore
const MerchantUserDetails = () => import('../entities/merchant-user/merchant-user-details.vue');
// prettier-ignore
const Merchant = () => import('../entities/merchant/merchant.vue');
// prettier-ignore
const MerchantUpdate = () => import('../entities/merchant/merchant-update.vue');
// prettier-ignore
const MerchantDetails = () => import('../entities/merchant/merchant-details.vue');
// prettier-ignore
const MerchantDocument = () => import('../entities/merchant-document/merchant-document.vue');
// prettier-ignore
const MerchantDocumentUpdate = () => import('../entities/merchant-document/merchant-document-update.vue');
// prettier-ignore
const MerchantDocumentDetails = () => import('../entities/merchant-document/merchant-document-details.vue');
// prettier-ignore
const Document = () => import('../entities/document/document.vue');
// prettier-ignore
const DocumentUpdate = () => import('../entities/document/document-update.vue');
// prettier-ignore
const DocumentDetails = () => import('../entities/document/document-details.vue');
// prettier-ignore
const Content = () => import('../entities/content/content.vue');
// prettier-ignore
const ContentUpdate = () => import('../entities/content/content-update.vue');
// prettier-ignore
const ContentDetails = () => import('../entities/content/content-details.vue');
// prettier-ignore
const Category = () => import('../entities/category/category.vue');
// prettier-ignore
const CategoryUpdate = () => import('../entities/category/category-update.vue');
// prettier-ignore
const CategoryDetails = () => import('../entities/category/category-details.vue');
// prettier-ignore
const Plan = () => import('../entities/plan/plan.vue');
// prettier-ignore
const PlanUpdate = () => import('../entities/plan/plan-update.vue');
// prettier-ignore
const PlanDetails = () => import('../entities/plan/plan-details.vue');
// prettier-ignore
const MerchantPlan = () => import('../entities/merchant-plan/merchant-plan.vue');
// prettier-ignore
const MerchantPlanUpdate = () => import('../entities/merchant-plan/merchant-plan-update.vue');
// prettier-ignore
const MerchantPlanDetails = () => import('../entities/merchant-plan/merchant-plan-details.vue');
// prettier-ignore
const MerchantFollowers = () => import('../entities/merchant-followers/merchant-followers.vue');
// prettier-ignore
const MerchantFollowersUpdate = () => import('../entities/merchant-followers/merchant-followers-update.vue');
// prettier-ignore
const MerchantFollowersDetails = () => import('../entities/merchant-followers/merchant-followers-details.vue');
// prettier-ignore
const MerchantLocationEmployee = () => import('../entities/merchant-location-employee/merchant-location-employee.vue');
// prettier-ignore
const MerchantLocationEmployeeUpdate = () => import('../entities/merchant-location-employee/merchant-location-employee-update.vue');
// prettier-ignore
const MerchantLocationEmployeeDetails = () => import('../entities/merchant-location-employee/merchant-location-employee-details.vue');
// prettier-ignore
const MerchantLocation = () => import('../entities/merchant-location/merchant-location.vue');
// prettier-ignore
const MerchantLocationUpdate = () => import('../entities/merchant-location/merchant-location-update.vue');
// prettier-ignore
const MerchantLocationDetails = () => import('../entities/merchant-location/merchant-location-details.vue');
// prettier-ignore
const MerchantPricePointRatioTrend = () => import('../entities/merchant-price-point-ratio-trend/merchant-price-point-ratio-trend.vue');
// prettier-ignore
const MerchantPricePointRatioTrendUpdate = () => import('../entities/merchant-price-point-ratio-trend/merchant-price-point-ratio-trend-update.vue');
// prettier-ignore
const MerchantPricePointRatioTrendDetails = () => import('../entities/merchant-price-point-ratio-trend/merchant-price-point-ratio-trend-details.vue');
// prettier-ignore
const MerchantPriceStampRatioTrend = () => import('../entities/merchant-price-stamp-ratio-trend/merchant-price-stamp-ratio-trend.vue');
// prettier-ignore
const MerchantPriceStampRatioTrendUpdate = () => import('../entities/merchant-price-stamp-ratio-trend/merchant-price-stamp-ratio-trend-update.vue');
// prettier-ignore
const MerchantPriceStampRatioTrendDetails = () => import('../entities/merchant-price-stamp-ratio-trend/merchant-price-stamp-ratio-trend-details.vue');
// prettier-ignore
const MerchantBarred = () => import('../entities/merchant-barred/merchant-barred.vue');
// prettier-ignore
const MerchantBarredUpdate = () => import('../entities/merchant-barred/merchant-barred-update.vue');
// prettier-ignore
const MerchantBarredDetails = () => import('../entities/merchant-barred/merchant-barred-details.vue');
// prettier-ignore
const MerchantEmployee = () => import('../entities/merchant-employee/merchant-employee.vue');
// prettier-ignore
const MerchantEmployeeUpdate = () => import('../entities/merchant-employee/merchant-employee-update.vue');
// prettier-ignore
const MerchantEmployeeDetails = () => import('../entities/merchant-employee/merchant-employee-details.vue');
// prettier-ignore
const NonUniqueVoucher = () => import('../entities/non-unique-voucher/non-unique-voucher.vue');
// prettier-ignore
const NonUniqueVoucherUpdate = () => import('../entities/non-unique-voucher/non-unique-voucher-update.vue');
// prettier-ignore
const NonUniqueVoucherDetails = () => import('../entities/non-unique-voucher/non-unique-voucher-details.vue');
// prettier-ignore
const PointsOffer = () => import('../entities/points-offer/points-offer.vue');
// prettier-ignore
const PointsOfferUpdate = () => import('../entities/points-offer/points-offer-update.vue');
// prettier-ignore
const PointsOfferDetails = () => import('../entities/points-offer/points-offer-details.vue');
// prettier-ignore
const PointsOfferLocation = () => import('../entities/points-offer-location/points-offer-location.vue');
// prettier-ignore
const PointsOfferLocationUpdate = () => import('../entities/points-offer-location/points-offer-location-update.vue');
// prettier-ignore
const PointsOfferLocationDetails = () => import('../entities/points-offer-location/points-offer-location-details.vue');
// prettier-ignore
const PointsOfferViewRating = () => import('../entities/points-offer-view-rating/points-offer-view-rating.vue');
// prettier-ignore
const PointsOfferViewRatingUpdate = () => import('../entities/points-offer-view-rating/points-offer-view-rating-update.vue');
// prettier-ignore
const PointsOfferViewRatingDetails = () => import('../entities/points-offer-view-rating/points-offer-view-rating-details.vue');
// prettier-ignore
const PaymentInvoice = () => import('../entities/payment-invoice/payment-invoice.vue');
// prettier-ignore
const PaymentInvoiceUpdate = () => import('../entities/payment-invoice/payment-invoice-update.vue');
// prettier-ignore
const PaymentInvoiceDetails = () => import('../entities/payment-invoice/payment-invoice-details.vue');
// prettier-ignore
const PaymentHistory = () => import('../entities/payment-history/payment-history.vue');
// prettier-ignore
const PaymentHistoryUpdate = () => import('../entities/payment-history/payment-history-update.vue');
// prettier-ignore
const PaymentHistoryDetails = () => import('../entities/payment-history/payment-history-details.vue');
// prettier-ignore
const PaymentSource = () => import('../entities/payment-source/payment-source.vue');
// prettier-ignore
const PaymentSourceUpdate = () => import('../entities/payment-source/payment-source-update.vue');
// prettier-ignore
const PaymentSourceDetails = () => import('../entities/payment-source/payment-source-details.vue');
// prettier-ignore
const MerchantPaymentOption = () => import('../entities/merchant-payment-option/merchant-payment-option.vue');
// prettier-ignore
const MerchantPaymentOptionUpdate = () => import('../entities/merchant-payment-option/merchant-payment-option-update.vue');
// prettier-ignore
const MerchantPaymentOptionDetails = () => import('../entities/merchant-payment-option/merchant-payment-option-details.vue');
// prettier-ignore
const MerchantDeposit = () => import('../entities/merchant-deposit/merchant-deposit.vue');
// prettier-ignore
const MerchantDepositUpdate = () => import('../entities/merchant-deposit/merchant-deposit-update.vue');
// prettier-ignore
const MerchantDepositDetails = () => import('../entities/merchant-deposit/merchant-deposit-details.vue');
// prettier-ignore
const RefundHistory = () => import('../entities/refund-history/refund-history.vue');
// prettier-ignore
const RefundHistoryUpdate = () => import('../entities/refund-history/refund-history-update.vue');
// prettier-ignore
const RefundHistoryDetails = () => import('../entities/refund-history/refund-history-details.vue');
// prettier-ignore
const PointsOfferTrend = () => import('../entities/points-offer-trend/points-offer-trend.vue');
// prettier-ignore
const PointsOfferTrendUpdate = () => import('../entities/points-offer-trend/points-offer-trend-update.vue');
// prettier-ignore
const PointsOfferTrendDetails = () => import('../entities/points-offer-trend/points-offer-trend-details.vue');
// prettier-ignore
const ShippableOffer = () => import('../entities/shippable-offer/shippable-offer.vue')
// prettier-ignore
const ShippableOfferUpdate = () => import('../entities/shippable-offer/shippable-offer-update.vue')
// prettier-ignore
const ShippableOfferDetails = () => import('../entities/shippable-offer/shippable-offer-details.vue')
// prettier-ignore
const StampsOffer = () => import('../entities/stamps-offer/stamps-offer.vue');
// prettier-ignore
const StampsOfferUpdate = () => import('../entities/stamps-offer/stamps-offer-update.vue');
// prettier-ignore
const StampsOfferDetails = () => import('../entities/stamps-offer/stamps-offer-details.vue');
// prettier-ignore
const StampsOfferLocation = () => import('../entities/stamps-offer-location/stamps-offer-location.vue');
// prettier-ignore
const StampsOfferLocationUpdate = () => import('../entities/stamps-offer-location/stamps-offer-location-update.vue');
// prettier-ignore
const StampsOfferLocationDetails = () => import('../entities/stamps-offer-location/stamps-offer-location-details.vue');
// prettier-ignore
const StampsOfferViewRating = () => import('../entities/stamps-offer-view-rating/stamps-offer-view-rating.vue');
// prettier-ignore
const StampsOfferViewRatingUpdate = () => import('../entities/stamps-offer-view-rating/stamps-offer-view-rating-update.vue');
// prettier-ignore
const StampsOfferViewRatingDetails = () => import('../entities/stamps-offer-view-rating/stamps-offer-view-rating-details.vue');
// prettier-ignore
const StampsOfferTrend = () => import('../entities/stamps-offer-trend/stamps-offer-trend.vue');
// prettier-ignore
const StampsOfferTrendUpdate = () => import('../entities/stamps-offer-trend/stamps-offer-trend-update.vue');
// prettier-ignore
const StampsOfferTrendDetails = () => import('../entities/stamps-offer-trend/stamps-offer-trend-details.vue');
// prettier-ignore
const UniqueVoucher = () => import('../entities/unique-voucher/unique-voucher.vue');
// prettier-ignore
const UniqueVoucherUpdate = () => import('../entities/unique-voucher/unique-voucher-update.vue');
// prettier-ignore
const UniqueVoucherDetails = () => import('../entities/unique-voucher/unique-voucher-details.vue');
// prettier-ignore
const UniqueVoucherGenerated = () => import('../entities/unique-voucher-generated/unique-voucher-generated.vue');
// prettier-ignore
const UniqueVoucherGeneratedUpdate = () => import('../entities/unique-voucher-generated/unique-voucher-generated-update.vue');
// prettier-ignore
const UniqueVoucherGeneratedDetails = () => import('../entities/unique-voucher-generated/unique-voucher-generated-details.vue');
// prettier-ignore
const MonthlyActiveUser = () => import('../entities/monthly-active-user/monthly-active-user.vue');
// prettier-ignore
const MonthlyActiveUserUpdate = () => import('../entities/monthly-active-user/monthly-active-user-update.vue');
// prettier-ignore
const MonthlyActiveUserDetails = () => import('../entities/monthly-active-user/monthly-active-user-details.vue');
// prettier-ignore
const MonthlyActiveUserCount = () => import('../entities/monthly-active-user-count/monthly-active-user-count.vue');
// prettier-ignore
const MonthlyActiveUserCountUpdate = () => import('../entities/monthly-active-user-count/monthly-active-user-count-update.vue');
// prettier-ignore
const MonthlyActiveUserCountDetails = () => import('../entities/monthly-active-user-count/monthly-active-user-count-details.vue');
// prettier-ignore
const UniqueVoucherLocation = () => import('../entities/unique-voucher-location/unique-voucher-location.vue');
// prettier-ignore
const UniqueVoucherLocationUpdate = () => import('../entities/unique-voucher-location/unique-voucher-location-update.vue');
// prettier-ignore
const UniqueVoucherLocationDetails = () => import('../entities/unique-voucher-location/unique-voucher-location-details.vue');
// prettier-ignore
const UniqueVoucherReviewRating = () => import('../entities/unique-voucher-review-rating/unique-voucher-review-rating.vue');
// prettier-ignore
const UniqueVoucherReviewRatingUpdate = () => import('../entities/unique-voucher-review-rating/unique-voucher-review-rating-update.vue');
// prettier-ignore
const UniqueVoucherReviewRatingDetails = () => import('../entities/unique-voucher-review-rating/unique-voucher-review-rating-details.vue');
// prettier-ignore
const UserPointsBalance = () => import('../entities/user-points-balance/user-points-balance.vue');
// prettier-ignore
const UserPointsBalanceUpdate = () => import('../entities/user-points-balance/user-points-balance-update.vue');
// prettier-ignore
const UserPointsBalanceDetails = () => import('../entities/user-points-balance/user-points-balance-details.vue');
// prettier-ignore
const UserPointsCollectionRequest = () => import('../entities/user-points-collection-request/user-points-collection-request.vue');
// prettier-ignore
const UserPointsCollectionRequestUpdate = () => import('../entities/user-points-collection-request/user-points-collection-request-update.vue');
// prettier-ignore
const UserPointsCollectionRequestDetails = () => import('../entities/user-points-collection-request/user-points-collection-request-details.vue');
// prettier-ignore
const UserPointsCollectionHistory = () => import('../entities/user-points-collection-history/user-points-collection-history.vue');
// prettier-ignore
const UserPointsCollectionHistoryUpdate = () => import('../entities/user-points-collection-history/user-points-collection-history-update.vue');
// prettier-ignore
const UserPointsCollectionHistoryDetails = () => import('../entities/user-points-collection-history/user-points-collection-history-details.vue');
// prettier-ignore
const UserPointsRedemptionHistory = () => import('../entities/user-points-redemption-history/user-points-redemption-history.vue');
// prettier-ignore
const UserPointsRedemptionHistoryUpdate = () => import('../entities/user-points-redemption-history/user-points-redemption-history-update.vue');
// prettier-ignore
const UserPointsRedemptionHistoryDetails = () => import('../entities/user-points-redemption-history/user-points-redemption-history-details.vue');
// prettier-ignore
const PointsOfferReviewRatingHistory = () => import('../entities/points-offer-review-rating-history/points-offer-review-rating-history.vue');
// prettier-ignore
const PointsOfferReviewRatingHistoryUpdate = () => import('../entities/points-offer-review-rating-history/points-offer-review-rating-history-update.vue');
// prettier-ignore
const PointsOfferReviewRatingHistoryDetails = () => import('../entities/points-offer-review-rating-history/points-offer-review-rating-history-details.vue');
// prettier-ignore
const StampsOfferReviewRatingHistory = () => import('../entities/stamps-offer-review-rating-history/stamps-offer-review-rating-history.vue');
// prettier-ignore
const StampsOfferReviewRatingHistoryUpdate = () => import('../entities/stamps-offer-review-rating-history/stamps-offer-review-rating-history-update.vue');
// prettier-ignore
const StampsOfferReviewRatingHistoryDetails = () => import('../entities/stamps-offer-review-rating-history/stamps-offer-review-rating-history-details.vue');
// prettier-ignore
const UniqueVoucherReviewRatingHistory = () => import('../entities/unique-voucher-review-rating-history/unique-voucher-review-rating-history.vue');
// prettier-ignore
const UniqueVoucherReviewRatingHistoryUpdate = () => import('../entities/unique-voucher-review-rating-history/unique-voucher-review-rating-history-update.vue');
// prettier-ignore
const UniqueVoucherReviewRatingHistoryDetails = () => import('../entities/unique-voucher-review-rating-history/unique-voucher-review-rating-history-details.vue');
// prettier-ignore
const UserPointsRedemptionRequest = () => import('../entities/user-points-redemption-request/user-points-redemption-request.vue');
// prettier-ignore
const UserPointsRedemptionRequestUpdate = () => import('../entities/user-points-redemption-request/user-points-redemption-request-update.vue');
// prettier-ignore
const UserPointsRedemptionRequestDetails = () => import('../entities/user-points-redemption-request/user-points-redemption-request-details.vue');
// prettier-ignore
const UserStampsBalance = () => import('../entities/user-stamps-balance/user-stamps-balance.vue');
// prettier-ignore
const UserStampsBalanceUpdate = () => import('../entities/user-stamps-balance/user-stamps-balance-update.vue');
// prettier-ignore
const UserStampsBalanceDetails = () => import('../entities/user-stamps-balance/user-stamps-balance-details.vue');
// prettier-ignore
const UserStampsCollectionHistory = () => import('../entities/user-stamps-collection-history/user-stamps-collection-history.vue');
// prettier-ignore
const UserStampsCollectionHistoryUpdate = () => import('../entities/user-stamps-collection-history/user-stamps-collection-history-update.vue');
// prettier-ignore
const UserStampsCollectionHistoryDetails = () => import('../entities/user-stamps-collection-history/user-stamps-collection-history-details.vue');
// prettier-ignore
const UserStampsRedemptionHistory = () => import('../entities/user-stamps-redemption-history/user-stamps-redemption-history.vue');
// prettier-ignore
const UserStampsRedemptionHistoryUpdate = () => import('../entities/user-stamps-redemption-history/user-stamps-redemption-history-update.vue');
// prettier-ignore
const UserStampsRedemptionHistoryDetails = () => import('../entities/user-stamps-redemption-history/user-stamps-redemption-history-details.vue');
// prettier-ignore
const InvitationToken = () => import('../entities/invitation-token/invitation-token.vue');
// prettier-ignore
const InvitationTokenUpdate = () => import('../entities/invitation-token/invitation-token-update.vue');
// prettier-ignore
const InvitationTokenDetails = () => import('../entities/invitation-token/invitation-token-details.vue');
// prettier-ignore
const LoyaltyStorage = () => import('../entities/loyalty-storage/loyalty-storage.vue');
// prettier-ignore
const LoyaltyStorageUpdate = () => import('../entities/loyalty-storage/loyalty-storage-update.vue');
// prettier-ignore
const LoyaltyStorageDetails = () => import('../entities/loyalty-storage/loyalty-storage-details.vue');
// prettier-ignore
const MerchantAttachment = () => import('../entities/merchant-attachment/merchant-attachment.vue');
// prettier-ignore
const MerchantAttachmentUpdate = () => import('../entities/merchant-attachment/merchant-attachment-update.vue');
// prettier-ignore
const MerchantAttachmentDetails = () => import('../entities/merchant-attachment/merchant-attachment-details.vue');
// prettier-ignore
const MerchantOfferAttachment = () => import('../entities/merchant-offer-attachment/merchant-offer-attachment.vue');
// prettier-ignore
const MerchantOfferAttachmentUpdate = () => import('../entities/merchant-offer-attachment/merchant-offer-attachment-update.vue');
// prettier-ignore
const MerchantOfferAttachmentDetails = () => import('../entities/merchant-offer-attachment/merchant-offer-attachment-details.vue');
// prettier-ignore
const NotificationJob = () => import('../entities/notification-job/notification-job.vue');
// prettier-ignore
const NotificationJobUpdate = () => import('../entities/notification-job/notification-job-update.vue');
// prettier-ignore
const NotificationJobDetails = () => import('../entities/notification-job/notification-job-details.vue');
// prettier-ignore
const OfferChallenge = () => import('../entities/offer-challenge/offer-challenge.vue');
// prettier-ignore
const OfferChallengeUpdate = () => import('../entities/offer-challenge/offer-challenge-update.vue');
// prettier-ignore
const OfferChallengeDetails = () => import('../entities/offer-challenge/offer-challenge-details.vue');
// prettier-ignore
const OfferOcrChallenge = () => import('../entities/offer-ocr-challenge/offer-ocr-challenge.vue');
// prettier-ignore
const OfferOcrChallengeUpdate = () => import('../entities/offer-ocr-challenge/offer-ocr-challenge-update.vue');
// prettier-ignore
const OfferOcrChallengeDetails = () => import('../entities/offer-ocr-challenge/offer-ocr-challenge-details.vue');
// prettier-ignore
const OfferUniqueCode = () => import('../entities/offer-unique-code/offer-unique-code.vue');
// prettier-ignore
const OfferUniqueCodeUpdate = () => import('../entities/offer-unique-code/offer-unique-code-update.vue');
// prettier-ignore
const OfferUniqueCodeDetails = () => import('../entities/offer-unique-code/offer-unique-code-details.vue');
// prettier-ignore
const StampsOfferViewRatingHistory = () => import('../entities/stamps-offer-view-rating-history/stamps-offer-view-rating-history.vue');
// prettier-ignore
const StampsOfferViewRatingHistoryUpdate = () => import('../entities/stamps-offer-view-rating-history/stamps-offer-view-rating-history-update.vue');
// prettier-ignore
const StampsOfferViewRatingHistoryDetails = () => import('../entities/stamps-offer-view-rating-history/stamps-offer-view-rating-history-details.vue');
// prettier-ignore
const UniqueVoucherGeneratedHistory = () => import('../entities/unique-voucher-generated-history/unique-voucher-generated-history.vue');
// prettier-ignore
const UniqueVoucherGeneratedHistoryUpdate = () => import('../entities/unique-voucher-generated-history/unique-voucher-generated-history-update.vue');
// prettier-ignore
const UniqueVoucherGeneratedHistoryDetails = () => import('../entities/unique-voucher-generated-history/unique-voucher-generated-history-details.vue');
// prettier-ignore
const UserAddress = () => import('../entities/user-address/user-address.vue');
// prettier-ignore
const UserAddressUpdate = () => import('../entities/user-address/user-address-update.vue');
// prettier-ignore
const UserAddressDetails = () => import('../entities/user-address/user-address-details.vue');
// prettier-ignore
const UserRedemptionUniqueCode = () => import('../entities/user-redemption-unique-code/user-redemption-unique-code.vue');
// prettier-ignore
const UserRedemptionUniqueCodeUpdate = () => import('../entities/user-redemption-unique-code/user-redemption-unique-code-update.vue');
// prettier-ignore
const UserRedemptionUniqueCodeDetails = () => import('../entities/user-redemption-unique-code/user-redemption-unique-code-details.vue');
// prettier-ignore
const UserStampsCollectionRequest = () => import('../entities/user-stamps-collection-request/user-stamps-collection-request.vue');
// prettier-ignore
const UserStampsCollectionRequestUpdate = () => import('../entities/user-stamps-collection-request/user-stamps-collection-request-update.vue');
// prettier-ignore
const UserStampsCollectionRequestDetails = () => import('../entities/user-stamps-collection-request/user-stamps-collection-request-details.vue');
// prettier-ignore
const UserStampsRedemptionRequest = () => import('../entities/user-stamps-redemption-request/user-stamps-redemption-request.vue');
// prettier-ignore
const UserStampsRedemptionRequestUpdate = () => import('../entities/user-stamps-redemption-request/user-stamps-redemption-request-update.vue');
// prettier-ignore
const UserStampsRedemptionRequestDetails = () => import('../entities/user-stamps-redemption-request/user-stamps-redemption-request-details.vue');
// prettier-ignore
const ShippingLogistic = () => import('../entities/shipping-logistic/shipping-logistic.vue');
// prettier-ignore
const ShippingLogisticUpdate = () => import('../entities/shipping-logistic/shipping-logistic-update.vue');
// prettier-ignore
const ShippingLogisticDetails = () => import('../entities/shipping-logistic/shipping-logistic-details.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here
// prettier-ignore
const OfferChallengeProduct = () => import('../entities/offer-challenge-product/offer-challenge-product.vue');
// prettier-ignore
const OfferChallengeProductUpdate = () => import('../entities/offer-challenge-product/offer-challenge-product-update.vue');
// prettier-ignore
const OfferChallengeProductDetails = () => import('../entities/offer-challenge-product/offer-challenge-product-details.vue');

const Countries = () => import('../entities/countries/countries.vue');

const CountryDetails = () => import('../entities/countries/country-details.vue');

const CountryUpdate = () => import('../entities/countries/country-update.vue');

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/activate',
      name: 'Activate',
      component: Activate
    },
    {
      path: '/reset/request',
      name: 'ResetPasswordInit',
      component: ResetPasswordInit
    },
    {
      path: '/reset/finish',
      name: 'ResetPasswordFinish',
      component: ResetPasswordFinish
    },
    {
      path: '/account/password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/account/settings',
      name: 'Settings',
      component: Settings,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/email',
      name: 'Email',
      component: Email,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/email-campaign',
      name: 'EmailCampaign',
      component: EmailCampaign,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/email-campaign/:id/edit',
      name: 'EmailCampaignEdit',
      component: EmailCampaignEditComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/email-campaign/:id/view',
      name: 'EmailCampaignView',
      component: EmailCampaignViewComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/user-management',
      name: 'JhiUser',
      component: JhiUserManagementComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/user-management/new',
      name: 'JhiUserCreate',
      component: JhiUserManagementEditComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/user-management/:userId/edit',
      name: 'JhiUserEdit',
      component: JhiUserManagementEditComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/user-management/:userId/view',
      name: 'JhiUserView',
      component: JhiUserManagementViewComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/docs',
      name: 'JhiDocsComponent',
      component: JhiDocsComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/audits',
      name: 'JhiAuditsComponent',
      component: JhiAuditsComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/jhi-health',
      name: 'JhiHealthComponent',
      component: JhiHealthComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/logs',
      name: 'JhiLogsComponent',
      component: JhiLogsComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/jhi-metrics',
      name: 'JhiMetricsComponent',
      component: JhiMetricsComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/admin/jhi-configuration',
      name: 'JhiConfigurationComponent',
      component: JhiConfigurationComponent,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-user',
      name: 'MerchantUser',
      component: MerchantUser,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-user/new',
      name: 'MerchantUserCreate',
      component: MerchantUserUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-user/:merchantUserId/edit',
      name: 'MerchantUserEdit',
      component: MerchantUserUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-user/:merchantUserId/view',
      name: 'MerchantUserView',
      component: MerchantUserDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant',
      name: 'Merchant',
      component: Merchant,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant/new',
      name: 'MerchantCreate',
      component: MerchantUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant/:merchantId/edit',
      name: 'MerchantEdit',
      component: MerchantUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant/:merchantId/view',
      name: 'MerchantView',
      component: MerchantDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-document',
      name: 'MerchantDocument',
      component: MerchantDocument,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-document/new',
      name: 'MerchantDocumentCreate',
      component: MerchantDocumentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-document/:merchantDocumentId/edit',
      name: 'MerchantDocumentEdit',
      component: MerchantDocumentUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-document/:merchantDocumentId/view',
      name: 'MerchantDocumentView',
      component: MerchantDocumentDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-document/:merchantId/view',
      name: 'MerchantDocumentView',
      component: MerchantDocumentDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/document',
      name: 'Document',
      component: Document,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/document/new',
      name: 'DocumentCreate',
      component: DocumentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/document/:documentId/edit',
      name: 'DocumentEdit',
      component: DocumentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/document/:documentId/view',
      name: 'DocumentView',
      component: DocumentDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/content',
      name: 'Content',
      component: Content,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/content/new',
      name: 'ContentCreate',
      component: ContentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/content/:contentId/edit',
      name: 'ContentEdit',
      component: ContentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/content/:contentId/view',
      name: 'ContentView',
      component: ContentDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/category',
      name: 'Category',
      component: Category,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/category/new',
      name: 'CategoryCreate',
      component: CategoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/category/:categoryId/edit',
      name: 'CategoryEdit',
      component: CategoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/category/:categoryId/view',
      name: 'CategoryView',
      component: CategoryDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/plan',
      name: 'Plan',
      component: Plan,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/plan/new',
      name: 'PlanCreate',
      component: PlanUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/plan/:planId/edit',
      name: 'PlanEdit',
      component: PlanUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/plan/:planId/view',
      name: 'PlanView',
      component: PlanDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-plan',
      name: 'MerchantPlan',
      component: MerchantPlan,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-plan/new',
      name: 'MerchantPlanCreate',
      component: MerchantPlanUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-plan/:merchantPlanId/edit',
      name: 'MerchantPlanEdit',
      component: MerchantPlanUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-plan/:merchantPlanId/view',
      name: 'MerchantPlanView',
      component: MerchantPlanDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-followers',
      name: 'MerchantFollowers',
      component: MerchantFollowers,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-followers/new',
      name: 'MerchantFollowersCreate',
      component: MerchantFollowersUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-followers/:merchantFollowersId/edit',
      name: 'MerchantFollowersEdit',
      component: MerchantFollowersUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-followers/:merchantFollowersId/view',
      name: 'MerchantFollowersView',
      component: MerchantFollowersDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-location-employee',
      name: 'MerchantLocationEmployee',
      component: MerchantLocationEmployee,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-location-employee/new',
      name: 'MerchantLocationEmployeeCreate',
      component: MerchantLocationEmployeeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-location-employee/:merchantLocationEmployeeId/edit',
      name: 'MerchantLocationEmployeeEdit',
      component: MerchantLocationEmployeeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-location-employee/:merchantLocationEmployeeId/view',
      name: 'MerchantLocationEmployeeView',
      component: MerchantLocationEmployeeDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-location',
      name: 'MerchantLocation',
      component: MerchantLocation,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-location/new',
      name: 'MerchantLocationCreate',
      component: MerchantLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-location/:merchantLocationId/edit',
      name: 'MerchantLocationEdit',
      component: MerchantLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-location/:merchantLocationId/view',
      name: 'MerchantLocationView',
      component: MerchantLocationDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-price-point-ratio-trend',
      name: 'MerchantPricePointRatioTrend',
      component: MerchantPricePointRatioTrend,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-price-point-ratio-trend/new',
      name: 'MerchantPricePointRatioTrendCreate',
      component: MerchantPricePointRatioTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-price-point-ratio-trend/:merchantPricePointRatioTrendId/edit',
      name: 'MerchantPricePointRatioTrendEdit',
      component: MerchantPricePointRatioTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-price-point-ratio-trend/:merchantPricePointRatioTrendId/view',
      name: 'MerchantPricePointRatioTrendView',
      component: MerchantPricePointRatioTrendDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-price-stamp-ratio-trend',
      name: 'MerchantPriceStampRatioTrend',
      component: MerchantPriceStampRatioTrend,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-price-stamp-ratio-trend/new',
      name: 'MerchantPriceStampRatioTrendCreate',
      component: MerchantPriceStampRatioTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-price-stamp-ratio-trend/:merchantPriceStampRatioTrendId/edit',
      name: 'MerchantPriceStampRatioTrendEdit',
      component: MerchantPriceStampRatioTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-price-stamp-ratio-trend/:merchantPriceStampRatioTrendId/view',
      name: 'MerchantPriceStampRatioTrendView',
      component: MerchantPriceStampRatioTrendDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-barred',
      name: 'MerchantBarred',
      component: MerchantBarred,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-barred/new',
      name: 'MerchantBarredCreate',
      component: MerchantBarredUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-barred/:merchantBarredId/edit',
      name: 'MerchantBarredEdit',
      component: MerchantBarredUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-barred/:merchantBarredId/view',
      name: 'MerchantBarredView',
      component: MerchantBarredDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/merchant-employee',
      name: 'MerchantEmployee',
      component: MerchantEmployee,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-employee/new',
      name: 'MerchantEmployeeCreate',
      component: MerchantEmployeeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-employee/:merchantEmployeeId/edit',
      name: 'MerchantEmployeeEdit',
      component: MerchantEmployeeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-employee/:merchantEmployeeId/view',
      name: 'MerchantEmployeeView',
      component: MerchantEmployeeDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/non-unique-voucher',
      name: 'NonUniqueVoucher',
      component: NonUniqueVoucher,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/non-unique-voucher/new',
      name: 'NonUniqueVoucherCreate',
      component: NonUniqueVoucherUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/non-unique-voucher/:nonUniqueVoucherId/edit',
      name: 'NonUniqueVoucherEdit',
      component: NonUniqueVoucherUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/non-unique-voucher/:nonUniqueVoucherId/view',
      name: 'NonUniqueVoucherView',
      component: NonUniqueVoucherDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/points-offer',
      name: 'PointsOffer',
      component: PointsOffer,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/points-offer/new',
      name: 'PointsOfferCreate',
      component: PointsOfferUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer/:pointsOfferId/edit',
      name: 'PointsOfferEdit',
      component: PointsOfferUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer/:pointsOfferId/view',
      name: 'PointsOfferView',
      component: PointsOfferDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/points-offer-location',
      name: 'PointsOfferLocation',
      component: PointsOfferLocation,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/points-offer-location/new',
      name: 'PointsOfferLocationCreate',
      component: PointsOfferLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-location/:pointsOfferLocationId/edit',
      name: 'PointsOfferLocationEdit',
      component: PointsOfferLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-location/:pointsOfferLocationId/view',
      name: 'PointsOfferLocationView',
      component: PointsOfferLocationDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/points-offer-view-rating',
      name: 'PointsOfferViewRating',
      component: PointsOfferViewRating,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/points-offer-view-rating/new',
      name: 'PointsOfferViewRatingCreate',
      component: PointsOfferViewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-view-rating/:pointsOfferViewRatingId/edit',
      name: 'PointsOfferViewRatingEdit',
      component: PointsOfferViewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-view-rating/:pointsOfferViewRatingId/view',
      name: 'PointsOfferViewRatingView',
      component: PointsOfferViewRatingDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/payment-invoice',
      name: 'PaymentInvoice',
      component: PaymentInvoice,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-invoice/new',
      name: 'PaymentInvoiceCreate',
      component: PaymentInvoiceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-invoice/:paymentInvoiceId/edit',
      name: 'PaymentInvoiceEdit',
      component: PaymentInvoiceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-invoice/:paymentInvoiceId/view',
      name: 'PaymentInvoiceView',
      component: PaymentInvoiceDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/payment-history',
      name: 'PaymentHistory',
      component: PaymentHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-history/new',
      name: 'PaymentHistoryCreate',
      component: PaymentHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-history/:paymentHistoryId/edit',
      name: 'PaymentHistoryEdit',
      component: PaymentHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-history/:paymentHistoryId/view',
      name: 'PaymentHistoryView',
      component: PaymentHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/payment-source',
      name: 'PaymentSource',
      component: PaymentSource,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-source/new',
      name: 'PaymentSourceCreate',
      component: PaymentSourceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-source/:paymentSourceId/edit',
      name: 'PaymentSourceEdit',
      component: PaymentSourceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/payment-source/:paymentSourceId/view',
      name: 'PaymentSourceView',
      component: PaymentSourceDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/merchant-payment-option',
      name: 'MerchantPaymentOption',
      component: MerchantPaymentOption,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-payment-option/new',
      name: 'MerchantPaymentOptionCreate',
      component: MerchantPaymentOptionUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-payment-option/:merchantPaymentOptionId/edit',
      name: 'MerchantPaymentOptionEdit',
      component: MerchantPaymentOptionUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-payment-option/:merchantPaymentOptionId/view',
      name: 'MerchantPaymentOptionView',
      component: MerchantPaymentOptionDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/merchant-deposit',
      name: 'MerchantDeposit',
      component: MerchantDeposit,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-deposit/new',
      name: 'MerchantDepositCreate',
      component: MerchantDepositUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-deposit/:merchantDepositId/edit',
      name: 'MerchantDepositEdit',
      component: MerchantDepositUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-deposit/:merchantDepositId/view',
      name: 'MerchantDepositView',
      component: MerchantDepositDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/refund-history',
      name: 'RefundHistory',
      component: RefundHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/refund-history/new',
      name: 'RefundHistoryCreate',
      component: RefundHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/refund-history/:refundHistoryId/edit',
      name: 'RefundHistoryEdit',
      component: RefundHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/refund-history/:refundHistoryId/view',
      name: 'RefundHistoryView',
      component: RefundHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/points-offer-trend',
      name: 'PointsOfferTrend',
      component: PointsOfferTrend,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/points-offer-trend/new',
      name: 'PointsOfferTrendCreate',
      component: PointsOfferTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-trend/:pointsOfferTrendId/edit',
      name: 'PointsOfferTrendEdit',
      component: PointsOfferTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-trend/:pointsOfferTrendId/view',
      name: 'PointsOfferTrendView',
      component: PointsOfferTrendDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shippable-offer',
      name: 'ShippableOffer',
      component: ShippableOffer,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shippable-offer/new',
      name: 'ShippableOfferCreate',
      component: ShippableOfferUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shippable-offer/:shippablesOfferId/edit',
      name: 'ShippableOfferEdit',
      component: ShippableOfferUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shippable-offer/:shippableOfferId/view',
      name: 'ShippableOfferView',
      component: ShippableOfferDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer',
      name: 'StampsOffer',
      component: StampsOffer,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer/new',
      name: 'StampsOfferCreate',
      component: StampsOfferUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer/:stampsOfferId/edit',
      name: 'StampsOfferEdit',
      component: StampsOfferUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer/:stampsOfferId/view',
      name: 'StampsOfferView',
      component: StampsOfferDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer-location',
      name: 'StampsOfferLocation',
      component: StampsOfferLocation,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer-location/new',
      name: 'StampsOfferLocationCreate',
      component: StampsOfferLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-location/:stampsOfferLocationId/edit',
      name: 'StampsOfferLocationEdit',
      component: StampsOfferLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-location/:stampsOfferLocationId/view',
      name: 'StampsOfferLocationView',
      component: StampsOfferLocationDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/stamps-offer-view-rating',
      name: 'StampsOfferViewRating',
      component: StampsOfferViewRating,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer-view-rating/new',
      name: 'StampsOfferViewRatingCreate',
      component: StampsOfferViewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-view-rating/:stampsOfferViewRatingId/edit',
      name: 'StampsOfferViewRatingEdit',
      component: StampsOfferViewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-view-rating/:stampsOfferViewRatingId/view',
      name: 'StampsOfferViewRatingView',
      component: StampsOfferViewRatingDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/stamps-offer-trend',
      name: 'StampsOfferTrend',
      component: StampsOfferTrend,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/stamps-offer-trend/new',
      name: 'StampsOfferTrendCreate',
      component: StampsOfferTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-trend/:stampsOfferTrendId/edit',
      name: 'StampsOfferTrendEdit',
      component: StampsOfferTrendUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-trend/:stampsOfferTrendId/view',
      name: 'StampsOfferTrendView',
      component: StampsOfferTrendDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher',
      name: 'UniqueVoucher',
      component: UniqueVoucher,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher/new',
      name: 'UniqueVoucherCreate',
      component: UniqueVoucherUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher/:uniqueVoucherId/edit',
      name: 'UniqueVoucherEdit',
      component: UniqueVoucherUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher/:uniqueVoucherId/view',
      name: 'UniqueVoucherView',
      component: UniqueVoucherDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher-generated',
      name: 'UniqueVoucherGenerated',
      component: UniqueVoucherGenerated,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher-generated/new',
      name: 'UniqueVoucherGeneratedCreate',
      component: UniqueVoucherGeneratedUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-generated/:uniqueVoucherGeneratedId/edit',
      name: 'UniqueVoucherGeneratedEdit',
      component: UniqueVoucherGeneratedUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-generated/:uniqueVoucherGeneratedId/view',
      name: 'UniqueVoucherGeneratedView',
      component: UniqueVoucherGeneratedDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/monthly-active-user',
      name: 'MonthlyActiveUser',
      component: MonthlyActiveUser,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user/new',
      name: 'MonthlyActiveUserCreate',
      component: MonthlyActiveUserUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user/:monthlyActiveUserId/edit',
      name: 'MonthlyActiveUserEdit',
      component: MonthlyActiveUserUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user/:monthlyActiveUserId/view',
      name: 'MonthlyActiveUserView',
      component: MonthlyActiveUserDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/monthly-active-user-count',
      name: 'MonthlyActiveUserCount',
      component: MonthlyActiveUserCount,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user-count/new',
      name: 'MonthlyActiveUserCountCreate',
      component: MonthlyActiveUserCountUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user-count/:monthlyActiveUserCountId/edit',
      name: 'MonthlyActiveUserCountEdit',
      component: MonthlyActiveUserCountUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/monthly-active-user-count/:monthlyActiveUserCountId/view',
      name: 'MonthlyActiveUserCountView',
      component: MonthlyActiveUserCountDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/unique-voucher-location',
      name: 'UniqueVoucherLocation',
      component: UniqueVoucherLocation,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher-location/new',
      name: 'UniqueVoucherLocationCreate',
      component: UniqueVoucherLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-location/:uniqueVoucherLocationId/edit',
      name: 'UniqueVoucherLocationEdit',
      component: UniqueVoucherLocationUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-location/:uniqueVoucherLocationId/view',
      name: 'UniqueVoucherLocationView',
      component: UniqueVoucherLocationDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/unique-voucher-review-rating',
      name: 'UniqueVoucherReviewRating',
      component: UniqueVoucherReviewRating,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher-review-rating/new',
      name: 'UniqueVoucherReviewRatingCreate',
      component: UniqueVoucherReviewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating/:uniqueVoucherReviewRatingId/edit',
      name: 'UniqueVoucherReviewRatingEdit',
      component: UniqueVoucherReviewRatingUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating/:uniqueVoucherReviewRatingId/view',
      name: 'UniqueVoucherReviewRatingView',
      component: UniqueVoucherReviewRatingDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-points-balance',
      name: 'UserPointsBalance',
      component: UserPointsBalance,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-points-balance/new',
      name: 'UserPointsBalanceCreate',
      component: UserPointsBalanceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-balance/:userPointsBalanceId/edit',
      name: 'UserPointsBalanceEdit',
      component: UserPointsBalanceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-balance/:userPointsBalanceId/view',
      name: 'UserPointsBalanceView',
      component: UserPointsBalanceDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-points-collection-request',
      name: 'UserPointsCollectionRequest',
      component: UserPointsCollectionRequest,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-points-collection-request/new',
      name: 'UserPointsCollectionRequestCreate',
      component: UserPointsCollectionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-collection-request/:userPointsCollectionRequestId/edit',
      name: 'UserPointsCollectionRequestEdit',
      component: UserPointsCollectionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-collection-request/:userPointsCollectionRequestId/view',
      name: 'UserPointsCollectionRequestView',
      component: UserPointsCollectionRequestDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-points-collection-history',
      name: 'UserPointsCollectionHistory',
      component: UserPointsCollectionHistory,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-points-collection-history/new',
      name: 'UserPointsCollectionHistoryCreate',
      component: UserPointsCollectionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-collection-history/:userPointsCollectionHistoryId/edit',
      name: 'UserPointsCollectionHistoryEdit',
      component: UserPointsCollectionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-collection-history/:userPointsCollectionHistoryId/view',
      name: 'UserPointsCollectionHistoryView',
      component: UserPointsCollectionHistoryDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-points-redemption-history',
      name: 'UserPointsRedemptionHistory',
      component: UserPointsRedemptionHistory,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-points-redemption-history/new',
      name: 'UserPointsRedemptionHistoryCreate',
      component: UserPointsRedemptionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-redemption-history/:userPointsRedemptionHistoryId/edit',
      name: 'UserPointsRedemptionHistoryEdit',
      component: UserPointsRedemptionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-redemption-history/:userPointsRedemptionHistoryId/view',
      name: 'UserPointsRedemptionHistoryView',
      component: UserPointsRedemptionHistoryDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/points-offer-review-rating-history',
      name: 'PointsOfferReviewRatingHistory',
      component: PointsOfferReviewRatingHistory,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/points-offer-review-rating-history/new',
      name: 'PointsOfferReviewRatingHistoryCreate',
      component: PointsOfferReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-review-rating-history/:pointsOfferReviewRatingHistoryId/edit',
      name: 'PointsOfferReviewRatingHistoryEdit',
      component: PointsOfferReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/points-offer-review-rating-history/:pointsOfferReviewRatingHistoryId/view',
      name: 'PointsOfferReviewRatingHistoryView',
      component: PointsOfferReviewRatingHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/stamps-offer-review-rating-history',
      name: 'StampsOfferReviewRatingHistory',
      component: StampsOfferReviewRatingHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-review-rating-history/new',
      name: 'StampsOfferReviewRatingHistoryCreate',
      component: StampsOfferReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-review-rating-history/:stampsOfferReviewRatingHistoryId/edit',
      name: 'StampsOfferReviewRatingHistoryEdit',
      component: StampsOfferReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-review-rating-history/:stampsOfferReviewRatingHistoryId/view',
      name: 'StampsOfferReviewRatingHistoryView',
      component: StampsOfferReviewRatingHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating-history',
      name: 'UniqueVoucherReviewRatingHistory',
      component: UniqueVoucherReviewRatingHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating-history/new',
      name: 'UniqueVoucherReviewRatingHistoryCreate',
      component: UniqueVoucherReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating-history/:uniqueVoucherReviewRatingHistoryId/edit',
      name: 'UniqueVoucherReviewRatingHistoryEdit',
      component: UniqueVoucherReviewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-review-rating-history/:uniqueVoucherReviewRatingHistoryId/view',
      name: 'UniqueVoucherReviewRatingHistoryView',
      component: UniqueVoucherReviewRatingHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-address',
      name: 'UserAddress',
      component: UserAddress,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-address/new',
      name: 'UserAddressCreate',
      component: UserAddressUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-address/:userAddressId/edit',
      name: 'UserAddressEdit',
      component: UserAddressUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-address/:userAddressId/view',
      name: 'UserAddressView',
      component: UserAddressDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-points-redemption-request',
      name: 'UserPointsRedemptionRequest',
      component: UserPointsRedemptionRequest,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-redemption-request/new',
      name: 'UserPointsRedemptionRequestCreate',
      component: UserPointsRedemptionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-redemption-request/:userPointsRedemptionRequestId/edit',
      name: 'UserPointsRedemptionRequestEdit',
      component: UserPointsRedemptionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-points-redemption-request/:userPointsRedemptionRequestId/view',
      name: 'UserPointsRedemptionRequestView',
      component: UserPointsRedemptionRequestDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/user-stamps-balance',
      name: 'UserStampsBalance',
      component: UserStampsBalance,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-stamps-balance/new',
      name: 'UserStampsBalanceCreate',
      component: UserStampsBalanceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-balance/:userStampsBalanceId/edit',
      name: 'UserStampsBalanceEdit',
      component: UserStampsBalanceUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-balance/:userStampsBalanceId/view',
      name: 'UserStampsBalanceView',
      component: UserStampsBalanceDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-stamps-collection-history',
      name: 'UserStampsCollectionHistory',
      component: UserStampsCollectionHistory,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/user-stamps-collection-history/new',
      name: 'UserStampsCollectionHistoryCreate',
      component: UserStampsCollectionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-collection-history/:userStampsCollectionHistoryId/edit',
      name: 'UserStampsCollectionHistoryEdit',
      component: UserStampsCollectionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-collection-history/:userStampsCollectionHistoryId/view',
      name: 'UserStampsCollectionHistoryView',
      component: UserStampsCollectionHistoryDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-stamps-redemption-history',
      name: 'UserStampsRedemptionHistory',
      component: UserStampsRedemptionHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-history/new',
      name: 'UserStampsRedemptionHistoryCreate',
      component: UserStampsRedemptionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-history/:userStampsRedemptionHistoryId/edit',
      name: 'UserStampsRedemptionHistoryEdit',
      component: UserStampsRedemptionHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-history/:userStampsRedemptionHistoryId/view',
      name: 'UserStampsRedemptionHistoryView',
      component: UserStampsRedemptionHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/invitation-token',
      name: 'InvitationToken',
      component: InvitationToken,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/invitation-token/new',
      name: 'InvitationTokenCreate',
      component: InvitationTokenUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/invitation-token/:invitationTokenId/edit',
      name: 'InvitationTokenEdit',
      component: InvitationTokenUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/invitation-token/:invitationTokenId/view',
      name: 'InvitationTokenView',
      component: InvitationTokenDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/loyalty-storage',
      name: 'LoyaltyStorage',
      component: LoyaltyStorage,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/loyalty-storage/new',
      name: 'LoyaltyStorageCreate',
      component: LoyaltyStorageUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/loyalty-storage/:loyaltyStorageId/edit',
      name: 'LoyaltyStorageEdit',
      component: LoyaltyStorageUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/loyalty-storage/:loyaltyStorageId/view',
      name: 'LoyaltyStorageView',
      component: LoyaltyStorageDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/merchant-attachment',
      name: 'MerchantAttachment',
      component: MerchantAttachment,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/merchant-attachment/new',
      name: 'MerchantAttachmentCreate',
      component: MerchantAttachmentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-attachment/:merchantAttachmentId/edit',
      name: 'MerchantAttachmentEdit',
      component: MerchantAttachmentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-attachment/:merchantAttachmentId/view',
      name: 'MerchantAttachmentView',
      component: MerchantAttachmentDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/merchant-offer-attachment',
      name: 'MerchantOfferAttachment',
      component: MerchantOfferAttachment,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-offer-attachment/new',
      name: 'MerchantOfferAttachmentCreate',
      component: MerchantOfferAttachmentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-offer-attachment/:merchantOfferAttachmentId/edit',
      name: 'MerchantOfferAttachmentEdit',
      component: MerchantOfferAttachmentUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/merchant-offer-attachment/:merchantOfferAttachmentId/view',
      name: 'MerchantOfferAttachmentView',
      component: MerchantOfferAttachmentDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/notification-job',
      name: 'NotificationJob',
      component: NotificationJob,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/notification-job/new',
      name: 'NotificationJobCreate',
      component: NotificationJobUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/notification-job/:notificationJobId/edit',
      name: 'NotificationJobEdit',
      component: NotificationJobUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/notification-job/:notificationJobId/view',
      name: 'NotificationJobView',
      component: NotificationJobDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/offer-challenge',
      name: 'OfferChallenge',
      component: OfferChallenge,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/offer-challenge/new',
      name: 'OfferChallengeCreate',
      component: OfferChallengeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-challenge/:offerChallengeId/edit',
      name: 'OfferChallengeEdit',
      component: OfferChallengeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-challenge/:offerChallengeId/view',
      name: 'OfferChallengeView',
      component: OfferChallengeDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/offer-ocr-challenge',
      name: 'OfferOcrChallenge',
      component: OfferOcrChallenge,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/offer-ocr-challenge/new',
      name: 'OfferOcrChallengeCreate',
      component: OfferOcrChallengeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-ocr-challenge/:offerOcrChallengeId/:search/edit',
      name: 'OfferOcrChallengeEdit',
      component: OfferOcrChallengeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-ocr-challenge/:offerOcrChallengeId/:search/view',
      name: 'OfferOcrChallengeView',
      component: OfferOcrChallengeDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/offer-unique-code',
      name: 'OfferUniqueCode',
      component: OfferUniqueCode,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-unique-code/new',
      name: 'OfferUniqueCodeCreate',
      component: OfferUniqueCodeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-unique-code/:offerUniqueCodeId/edit',
      name: 'OfferUniqueCodeEdit',
      component: OfferUniqueCodeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-unique-code/:offerUniqueCodeId/view',
      name: 'OfferUniqueCodeView',
      component: OfferUniqueCodeDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/stamps-offer-view-rating-history',
      name: 'StampsOfferViewRatingHistory',
      component: StampsOfferViewRatingHistory,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-view-rating-history/new',
      name: 'StampsOfferViewRatingHistoryCreate',
      component: StampsOfferViewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-view-rating-history/:stampsOfferViewRatingHistoryId/edit',
      name: 'StampsOfferViewRatingHistoryEdit',
      component: StampsOfferViewRatingHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/stamps-offer-view-rating-history/:stampsOfferViewRatingHistoryId/view',
      name: 'StampsOfferViewRatingHistoryView',
      component: StampsOfferViewRatingHistoryDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/unique-voucher-generated-history',
      name: 'UniqueVoucherGeneratedHistory',
      component: UniqueVoucherGeneratedHistory,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/unique-voucher-generated-history/new',
      name: 'UniqueVoucherGeneratedHistoryCreate',
      component: UniqueVoucherGeneratedHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-generated-history/:uniqueVoucherGeneratedHistoryId/edit',
      name: 'UniqueVoucherGeneratedHistoryEdit',
      component: UniqueVoucherGeneratedHistoryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/unique-voucher-generated-history/:uniqueVoucherGeneratedHistoryId/view',
      name: 'UniqueVoucherGeneratedHistoryView',
      component: UniqueVoucherGeneratedHistoryDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    }
    ,
    {
      path: '/entity/user-redemption-unique-code',
      name: 'UserRedemptionUniqueCode',
      component: UserRedemptionUniqueCode,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-redemption-unique-code/new',
      name: 'UserRedemptionUniqueCodeCreate',
      component: UserRedemptionUniqueCodeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-redemption-unique-code/:userRedemptionUniqueCodeId/edit',
      name: 'UserRedemptionUniqueCodeEdit',
      component: UserRedemptionUniqueCodeUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-redemption-unique-code/:userRedemptionUniqueCodeId/view',
      name: 'UserRedemptionUniqueCodeView',
      component: UserRedemptionUniqueCodeDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/user-stamps-collection-request',
      name: 'UserStampsCollectionRequest',
      component: UserStampsCollectionRequest,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-collection-request/new',
      name: 'UserStampsCollectionRequestCreate',
      component: UserStampsCollectionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-collection-request/:userStampsCollectionRequestId/edit',
      name: 'UserStampsCollectionRequestEdit',
      component: UserStampsCollectionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-collection-request/:userStampsCollectionRequestId/view',
      name: 'UserStampsCollectionRequestView',
      component: UserStampsCollectionRequestDetails,
      meta: { authorities: ['ROLE_USER'] }
    }
    ,
    {
      path: '/entity/user-stamps-redemption-request',
      name: 'UserStampsRedemptionRequest',
      component: UserStampsRedemptionRequest,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-request/new',
      name: 'UserStampsRedemptionRequestCreate',
      component: UserStampsRedemptionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-request/:userStampsRedemptionRequestId/edit',
      name: 'UserStampsRedemptionRequestEdit',
      component: UserStampsRedemptionRequestUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/user-stamps-redemption-request/:userStampsRedemptionRequestId/view',
      name: 'UserStampsRedemptionRequestView',
      component: UserStampsRedemptionRequestDetails,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/shipping-logistic',
      name: 'ShippingLogistic',
      component: ShippingLogistic,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shipping-logistic/new',
      name: 'ShippingLogisticCreate',
      component: ShippingLogisticUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shipping-logistic/:shippingLogisticId/view',
      name: 'ShippingLogisticView',
      component: ShippingLogisticDetails,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/shipping-logistic/:shippingLogisticId/edit',
      name: 'ShippingLogisticEdit',
      component: ShippingLogisticUpdate,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
    ,
    {
      path: '/entity/offer-challenge-product',
      name: 'OfferChallengeProduct',
      component: OfferChallengeProduct,
      meta: { authorities: ['ROLE_ADMIN','SUPER_ADMIN'] }
    },
    {
      path: '/entity/offer-challenge-product/new',
      name: 'OfferChallengeProductCreate',
      component: OfferChallengeProductUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-challenge-product/:offerChallengeProductId/edit',
      name: 'OfferChallengeProductEdit',
      component: OfferChallengeProductUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/offer-challenge-product/:offerChallengeProductId/view',
      name: 'OfferChallengeProductView',
      component: OfferChallengeProductDetails,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/countries',
      name: 'Countries',
      component: Countries,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/countries/:iso/view',
      name: 'CountryView',
      component: CountryDetails,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/countries/:iso/edit',
      name: 'CountryEdit',
      component: CountryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
    {
      path: '/entity/countriest/new',
      name: 'CountryCreate',
      component: CountryUpdate,
      meta: { authorities: ['ROLE_USER'] }
    },
  ]
});
